module.exports = function (data) {
    if (data.product) {
        data.product.SalePrice = data.product.SalePrice > 0 ? data.product.SalePrice : -data.product.SalePrice; // remove negative SalePrice
        let quantity = data.product.Quantity > 0 ? data.product.Quantity : -data.product.Quantity; // remove negative quantity

        //product could be partially unavailable - quantity and price should need to adjust
        if (data.product.UnavailableStock > 0 && data.product.UnavailableStock < quantity
            && Array.isArray(data.product.AssociatedProducts)) {

            const productDetails = data.product.AssociatedProducts.find(function (product) {
                if (product.Stockcode === data.product.Stockcode) {
                    return product;
                }
            });

            if (productDetails != null) {
                quantity = data.product.UnavailableStock;
                data.product.SalePrice = productDetails.Price * quantity;
            }
        }

        return {
            event: 'BWSAUremoveFromCart',
            eventContext: {
                area: data.area,
                quantity,
                unitPrice: data.product.SalePrice,
                unitDisplay: data.product.Unit,
                productInfo: data.product.ProductData,
                isOnSpecial: data.product.IsSpecial ? 'true' : 'false'
            }
        };
    }
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/atmmapper/remove-from-trolley-mapper.js
 **/